import { render, staticRenderFns } from "./LeagueTable.vue?vue&type=template&id=a0811188&scoped=true"
import script from "./LeagueTable.vue?vue&type=script&lang=js"
export * from "./LeagueTable.vue?vue&type=script&lang=js"
import style0 from "./LeagueTable.vue?vue&type=style&index=0&id=a0811188&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a0811188",
  null
  
)

export default component.exports